module.exports = __webpack_public_path__ + "media/images/pages/trade-5-elements-a6ff6460d2afb1a52be2c25752e975a2.svg";